"use strict";

// src/polyfill.ts
var import_es_array_find_last = require("core-js/modules/es.array.find-last.js");
var import_es_array_find_last_index = require("core-js/modules/es.array.find-last-index.js");
var import_es_array_push = require("core-js/modules/es.array.push.js");
var import_es_array_unshift = require("core-js/modules/es.array.unshift.js");
var import_es_regexp_flags = require("core-js/modules/es.regexp.flags.js");
var import_es_typed_array_find_last = require("core-js/modules/es.typed-array.find-last.js");
var import_es_typed_array_find_last_index = require("core-js/modules/es.typed-array.find-last-index.js");
var import_web_dom_exception_stack = require("core-js/modules/web.dom-exception.stack.js");
var import_web_immediate = require("core-js/modules/web.immediate.js");
var import_web_structured_clone = require("core-js/modules/web.structured-clone.js");

// src/index.ts
var import_whatwg_fetch = require("whatwg-fetch");
var import_focus_visible = require("focus-visible");
